/*** Regex to match whitespace */
export const whitespaceReplaceRegExp = /\s+/g

/** Regex to match symbols (preserves `+`, `%`, `@` symbols) */
export const symbolReplaceRegExp = /[^a-z0-9+%@]/gi

/** Regex to match non-alphanumeric characters */
export const nonAlphaNumRegExp = /[^a-z0-9]/gi

/** Regex to match diacritics */
export const diacriticsReplaceRegExp = /[\u0300-\u036f]/g

/** Regex to match alphanumeric characters */
export const alphaNumRegExp = /^[a-zA-Z0-9]+$/

/** Regex to match every UUID in a string. Matches any UUID version, older ones included. */
export const uuidReplaceRegExp = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi
